import {
    AfterContentChecked,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { CustomerService } from '../../customer-billing-customer/customer.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { CustomerBillingOtherCustomerModel } from '../customer-billing-other-customer.model';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { BillingService } from '@fi-app/billing/billing.service';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-customer-billing-other-customer-edit',
    templateUrl: './customer-billing-other-customer-edit.component.html',
    styleUrls: ['./customer-billing-other-customer-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-other-customer-edit' },
    standalone: false,
})
export class CustomerBillingOtherCustomerEditComponent implements OnInit, AfterContentChecked {
    @Input() customer: CustomerBillingOtherCustomerModel;
    @Input() resellers: CustomerBillingOtherCustomerModel[];

    EditTabs: EditTabsModel;
    resellerListData = new DropdownSettingsModelV2<CustomerBillingOtherCustomerModel>();

    constructor(
        private appTextService: AppTextService,
        private customerService: CustomerService,
        private billingService: BillingService,
        private contentLanguages: ContentLanguagesService,
        private fiLoadingService: LoadingService,
        private stateService: FiStateService,
        private objectTitleService: ObjectTitleService,
        private cdRef: ChangeDetectorRef,
    ) {}

    ngAfterContentChecked() {
        this.cdRef.detectChanges();
    }

    ngOnInit() {
        this.resellerListData.setDataSet(this.resellers);
        this.setHeaderPageData();
    }

    private setHeaderPageData() {
        this.EditTabs = new EditTabsModel(this.getPageTitle());
        this.EditTabs.Tabs.push(
            new EditTabModel(this.appTextService.get('common.general'), this.appTextService.get('common.general')),
        );
    }

    private getPageTitle(): string {
        return this.customer.Id
            ? this.objectTitleService.getEditTitle(this.customer.Name)
            : this.objectTitleService.getCreateTitle(ObjectTypes.CustomerBillingCustomer);
    }

    save() {
        this.fiLoadingService.trackPromise(this.customerService.SaveOtherBillingCustomer(this.customer)).then(() => {
            this.stateService.go(FiStateNames.CustomerBilling.OtherCustomers.List);
        });
    }
}
